import { Base } from "ui/Scripts/source/framework/base";

export interface IGroupPermission {
    id: string;
    code: string;
    level: number;
    type: number;
}

export class GroupPermission implements IGroupPermission {
    id: string;
    code: string;
    level: number;
    type: number;

    constructor();
    constructor(obj: IGroupPermission);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.level = obj && obj.level || 0;
        this.type = obj && obj.type || 0;
    }

    static sortGroupPermissions(items: IGroupPermission[]) {
        if (!items && items.length < 2) return;
        items.sort((a: IGroupPermission, b: IGroupPermission) => {
            if (!a || !b) return 0;
            const result = Base.numCompare(a.type, b.type);
            if (result !== 0) return result;
            return Base.strCompare(a.code, b.code);
        });
    }
}